import { render, staticRenderFns } from "./mallPicture2.vue?vue&type=template&id=8eed2a50&scoped=true"
import script from "./mallPicture2.vue?vue&type=script&lang=js"
export * from "./mallPicture2.vue?vue&type=script&lang=js"
import style0 from "./mallPicture2.vue?vue&type=style&index=0&id=8eed2a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eed2a50",
  null
  
)

export default component.exports